<template>
  <div class="searchDialog">
    <div
      class="input"
      :style="{ margin: 'auto 0 auto 50px', padding: '20px 0 0 0' }"
    >
      <el-popover
        placement="bottom-start"
        width="160"
        trigger="manual"
        v-model="visible"
        ref="popover"
      >
        <template slot="reference">
          <input
            type="text"
            v-model="keyword"
            :style="{ width: '700px', height: '54px', fontSize: '14px' }"
            placeholder="输入关键词搜索..."
            @keyup.enter="handleSearch"
            @focus="displayArr"
            @blur="visible = false"
            @click="displayArr"
            :class="isHover ? 'bcc' : ''"
          />
        </template>
        <div>
          <ul>
            <li
              v-for="item in arr"
              :key="item"
              :style="{ padding: '8px 0 8px 10px' }"
              @click="chooseKey(item, '1')"
              @mouseover="chooseKey(item)"
              @mouseleave="chooseKeyIs('')"
            >
              {{ item }}
              <i
                class="el-icon-close"
                @click.stop="deleteArr(item)"
                @mouseover.stop="showDeleteText(item)"
                @mouseleave.stop="hideDeleteText(item)"
              ></i>
              <span
                :style="{ display: deleteTextVisible[item] ? 'block' : 'none' }"
                >删除条目</span
              >
            </li>
          </ul>
        </div>
      </el-popover>

      <img
        src="../assets/images/search-red.png"
        alt=""
        :style="{ right: '70px', top: '40px' }"
        @click="handleSearch"
      />
      <span
        :style="{ width: '16px', height: '16px', right: '20px', top: '44px' }"
        @click="closeSearch"
      ></span>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      keyword: "",
      arr: [],
      visible: false,
      isChoose: false,
      isHover: false,
      deleteTextVisible: {},
    };
  },
  methods: {
    closeSearch() {
      this.$store.commit("openSearch");
    },
    handleSearch() {
      if (this.keyword) {
        if (!this.arr.includes(this.keyword)) {
          this.arr.push(this.keyword);
        }

        localStorage.setItem("keywords", JSON.stringify(this.arr));

        const searchUrl = `https://www.fanvil.com.cn/search.aspx?keywords=${encodeURIComponent(
          this.keyword
        )}`;

        window.location.href = searchUrl;
      } else {
        console.warn("keyword is empty or undefined");
      }
    },
    getArr() {
      const storedKeywords = localStorage.getItem("keywords");
      if (storedKeywords) {
        this.arr = JSON.parse(storedKeywords).slice(0, 6);
        this.keyword = this.arr[this.arr.length - 1];
      } else {
        this.arr = [];
      }
    },

    displayArr() {
      if (!this.keyword) {
        this.visible = true;
        const storedKeywords = JSON.parse(localStorage.getItem("keywords"));
        if (storedKeywords.length) {
          this.arr = storedKeywords.slice(0, 6);
        } else {
          this.arr = [];
          this.visible = false;
        }
      } else {
        this.visible = false;
      }
    },

    deleteArr(val) {
      this.arr = this.arr.filter((item) => {
        return item != val;
      });
      localStorage.setItem("keywords", JSON.stringify(this.arr));
    },

    chooseKey(val, type) {
      this.keyword = val;
      type ? (this.isChoose = true) : (this.isHover = true);
    },

    chooseKeyIs(val) {
      this.isHover = false;
      this.isChoose ? "" : (this.keyword = val);
    },

    showDeleteText(item) {
      this.$set(this.deleteTextVisible, item, true);
      this.keyword = "";
      this.isHover = false;
    },

    hideDeleteText(item) {
      this.$set(this.deleteTextVisible, item, false);
    },
  },

  created() {
    this.getArr();
  },
};
</script>
  
  <style lang="less" scoped>
.searchDialog {
  background-color: rgb(255, 255, 255);
  box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 100px;
  top: 110px;
  .input {
    position: relative;
  }

  input {
    border: 1px solid transparent;
    border-bottom: 1px solid red;
    padding: 0;
    font-weight: bolder;
    color: #666;
    outline: none;
  }

  .bcc {
    background-color: #e8f0fe;
  }

  input::placeholder {
    color: #999999;
  }

  input:focus {
    border-bottom: 1px solid red;
  }

  img {
    position: absolute;
    cursor: pointer;
  }

  span {
    position: absolute;
    background-color: red;
    background: url(../assets/images/close-g.png) center center / contain
      no-repeat;

    &:hover {
      background: url(../assets/images/close-r.png) center center / contain
        no-repeat;
      cursor: pointer;
    }
  }
}

.el-popover {
  > div {
    ul {
      padding: 0;
      margin: 0.25rem;
      li {
        list-style: none;
        border-radius: 0.3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: default;
        margin: 0;
        position: relative;

        &:hover {
          background-color: #f2f2f2;

          i {
            display: block;
          }
        }

        i {
          display: block;
          margin-right: 0.5rem;
          border-radius: 50%;
          padding: 0.15rem;

          &:hover {
            background-color: #dddddd;
          }
        }
        span {
          display: none;
          position: absolute;
          bottom: -0.6rem;
          right: -4rem;
          border: 1px solid black;
          background-color: #ffffff;
          padding: 0.05rem 0.1rem;
        }
      }
    }
  }
}
</style>